module.exports = __webpack_public_path__ + "static/img/pay-en-btn.54a96f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-en-btn.png
// module id = YABr
// module chunks = 1